import React from 'react';
// import PropTypes from 'prop-types';
import styles from 'styles/components/lib/buttons/buttonGroup.css';

export default class ButtonGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentValue: props.selectedValue
    }
    this.getChildren = this.getChildren.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  componentWillReceiveProps(nProps) {
    if (nProps.selectedValue !== this.props.selectedValue) {
      this.setState({currentValue: nProps.selectedValue});
    }
  }
  getChildren(children) {
    let { currentValue } = this.state;

    return React.Children.map(children, (child, key) => {
         let isActive = false;
         let value = child.props.value !== undefined ?
          child.props.value : child.props.label;


           if (typeof value === 'string' ) {
            isActive = (value.toLowerCase() === currentValue.toLowerCase());
           } else {
             isActive = (value === currentValue);
           }

         return React.cloneElement(child, {
            key: key,
            onClick:  (e) => this.handleClick(e, value),
            className:  this.props.className,
            status: isActive ? 'active' : 'inactive',
            selected: isActive
          });
        });
  }
  handleClick(e, value) {
    if (value !== this.state.currentValue) {
      this.setState({
        currentValue: value
      }, () => {
        this.props.onChange(value);
      });
    }
  }
  render() {
    let {children ,className, selectedValue, style, ...props} = this.props;
    let classes = [styles.buttonGroup].concat(className).join(' ');
    return (
      <div className={classes} style={style} {...props} >
        { this.getChildren(children) }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/lib/buttons/ButtonGroup.js